import { Component, Input } from '@angular/core';

@Component({
    selector: 'best-performing-posts-placeholder',
    templateUrl: './best-performing-posts-placeholder.component.html',
    styleUrls: ['./best-performing-posts-placeholder.component.scss']
})
export class BestPerformingPostsPlacholderComponent {
    public posts = Array.from(Array(10).keys());

    @Input() printMode: boolean;
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-posts/best-performing-posts-placeholder/best-performing-posts-placeholder.component.ts